import { useWallet } from '../lib/useWallet'
import { cn } from '../lib/utils'
import { motion } from 'framer-motion'

interface WalletConnectProps {
  className?: string
}

export function WalletConnect({ className }: WalletConnectProps) {
  const { isConnected, isConnecting, address, connect } = useWallet()
  
  const formatAddress = (address?: string) => {
    if (!address) return ''
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`
  }

  return (
    <motion.button 
      className={cn(
        'h-[35px] bg-primary-400 w-[138px] rounded-xl flex items-center justify-center shadow-soft',
        isConnecting && 'opacity-80 cursor-wait',
        isConnected && 'cursor-default',
        className
      )}
      whileTap={!isConnected ? { scale: 0.98 } : {}}
      onClick={!isConnected ? connect : undefined}
      disabled={isConnecting || isConnected}
    >
      <span className="font-sf-pro font-bold text-white text-sm">
        {isConnecting ? 'Connecting...' : 
         isConnected ? formatAddress(address) : 'Connect Wallet'}
      </span>
    </motion.button>
  )
}
